import { Link } from 'react-router-dom';

export default function CommonFooter() {
  return (
    <footer className="bg-stone-100 py-16 px-6 pb-20 md:pb-16" id="access">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* ロゴ・紹介 */}
          <div className="space-y-6">
            <img
              src="https://storage.googleapis.com/studio-design-asset-files/projects/Kwa5AGrYaX/s-1322x482_v-fms_webp_7d01fee7-6e4e-4d9f-82e3-16315023dc88_small.webp"
              alt="さいわいデンタルクリニック moyuk SAPPORO"
              className="h-10 w-auto object-contain"
            />
            <p className="text-sm text-gray-600 font-light leading-relaxed">
              さいわいデンタルクリニックは、<br />
              北海道で、矯正を考えたときに最初に相談する場所です。
            </p>
          </div>

          {/* アクセス */}
          <div className="space-y-4">
            <h3 className="text-base font-normal text-gray-900 font-serif">アクセス</h3>
            <div className="space-y-3 text-sm text-gray-600 font-light leading-relaxed">
              <p>
                〒060-0062<br />
                北海道札幌市中央区南２条西３丁目２０番地<br />
                moyuk SAPPORO 2F
              </p>
              <p>チカホ直結</p>
              <p>土日診療対応</p>
            </div>
          </div>

          {/* 診療時間 */}
          <div className="space-y-4">
            <h3 className="text-base font-normal text-gray-900 font-serif">診療時間</h3>
            <div className="space-y-2 text-sm text-gray-600 font-light leading-relaxed">
              <p>平日 10:00 - 19:00（受付終了18:00）</p>
              <p>土日 10:00 - 19:00（受付終了18:00）</p>
              <p className="pt-2">定休日：祝日・月曜日</p>
            </div>
          </div>

          {/* 電話・予約・リンク */}
          <div className="space-y-4">
            <h3 className="text-base font-normal text-gray-900 font-serif">お問い合わせ</h3>
            <div className="space-y-3 text-sm text-gray-600 font-light leading-relaxed">
              <a
                href="tel:05018094594"
                className="hover:text-gray-900 transition-colors cursor-pointer flex items-center gap-2"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line" />
                </span>
                050-1809-4594
              </a>
              <a
                href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 text-white rounded-full px-8 py-3 transition-all duration-300 cursor-pointer whitespace-nowrap hover:opacity-90 text-sm font-medium"
                style={{ backgroundColor: '#3E5F8F' }}
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-calendar-line" />
                </span>
                WEB予約
              </a>
            </div>
            <div className="space-y-2 pt-2">
              <h4 className="text-sm font-normal text-gray-900">ページ</h4>
              <Link to="/" className="block text-sm text-gray-600 hover:text-gray-900 transition-colors">TOP</Link>
              <Link to="/mouthpiece" className="block text-sm text-gray-600 hover:text-gray-900 transition-colors">マウスピース矯正</Link>
              <Link to="/whitening" className="block text-sm text-gray-600 hover:text-gray-900 transition-colors">ホワイトニング</Link>
              <Link to="/icon" className="block text-sm text-gray-600 hover:text-gray-900 transition-colors">ICON白斑治療</Link>
              <Link to="/philosophy" className="block text-sm text-gray-600 hover:text-gray-900 transition-colors">治療について</Link>
            </div>
          </div>
        </div>

        {/* 地図 */}
        <div className="mb-12 w-full h-[400px] overflow-hidden rounded-lg">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2915.2329144612245!2d141.3505935765063!3d43.05756869075008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5f0b293393c34929%3A0x449b90dc73e7aad8!2z44GV44GE44KP44GE44OH44Oz44K_44Or44Kv44Oq44OL44OD44KvbW95dWsgU0FQUE9STw!5e0!3m2!1sja!2sjp!4v1771829649072!5m2!1sja!2sjp"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="moyuk SAPPORO 地図"
          />
        </div>

        {/* 他院リンク */}
        <div className="mb-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://saiwaidental.jp/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="w-64 inline-flex items-center justify-center gap-2 px-6 py-4 bg-white border-2 rounded-full text-sm font-medium hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
            style={{ borderColor: '#3E5F8F', color: '#3E5F8F' }}
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line" />
            </span>
            北広島院 WEBサイト
          </a>
          <a
            href="https://ohmagarisaiwaidental.jp/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="w-64 inline-flex items-center justify-center gap-2 px-6 py-4 bg-white border-2 rounded-full text-sm font-medium hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
            style={{ borderColor: '#3E5F8F', color: '#3E5F8F' }}
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line" />
            </span>
            大曲院 WEBサイト
          </a>
          <a
            href="https://saiwaidental.jp/shinsapporo/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="w-64 inline-flex items-center justify-center gap-2 px-6 py-4 bg-white border-2 rounded-full text-sm font-medium hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
            style={{ borderColor: '#3E5F8F', color: '#3E5F8F' }}
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line" />
            </span>
            新札幌院 WEBサイト
          </a>
        </div>

        {/* コピーライト */}
        <div className="pt-8 border-t border-gray-300 flex flex-col md:flex-row items-center justify-center gap-4 text-xs text-gray-500">
          <p>&copy; 2026 saiwaidentalclinic. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
